import { ROUTE } from '../../../../routes';
export const GoBack = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.KYC_STEPPER);
};
export const NavToBorrowerPanDetails = async (action, _datastore, { instrumentTrack, navigate }) => {
    await navigate(ROUTE.CO_BORROWER_PAN);
};
